import { BudgetEntityClient } from '@frontend/budget/api';
import { Budget, BudgetEntity } from '@frontend/budget/types';
import { EntityType } from '@frontend/common';
import { ErrorHandler } from '@frontend/error-handler';
import { CommonMessage } from '@frontend/lang';
import { useModals } from '@frontend/modal';
import { ToastUtil } from '@frontend/toast-utils';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

interface ViewProps {
    selectedObjects: Budget[];
    changeSelectedObjects: React.Dispatch<React.SetStateAction<Budget[]>>;
    onLink: () => void;
    openModal: ReturnType<typeof useModals>['openModal'];
    closeModal: ReturnType<typeof useModals>['closeModal'];
    linkModalId: string;
}

const useLinkBudgetToUserGroup = (): ViewProps => {
    const { groupId } = useParams();
    const navigate = useNavigate();
    const [selectedObjects, changeSelectedObjects] = useState<Budget[]>([]);
    const { openModal, closeModal } = useModals();
    const linkModalId = 'link-budget-to-user-confirmation-modal';

    const onLink = async () => {
        if (!groupId) return;
        const budgets: Promise<BudgetEntity>[] = [];

        selectedObjects.forEach((budget) => {
            budgets.push(BudgetEntityClient.postBudgetEntity(budget.account_id, budget.id, { entity_type: EntityType.USER_GROUP, entity_id: groupId }));
        });

        await Promise.all(budgets)
            .then(() => {
                ToastUtil.success(CommonMessage.TOAST.PROMISE.SUCCESS, CommonMessage.TOAST.CREATE.SUCCESS(CommonMessage.OBJECTS.BUDGET.PLURAL));
                closeModal(linkModalId);
                navigate(-1);
            })
            .catch(ErrorHandler.handleError);
    };

    return {
        changeSelectedObjects,
        selectedObjects,
        onLink,
        openModal,
        closeModal,
        linkModalId
    };
};

export default useLinkBudgetToUserGroup;
